export const IntegrationsAPIStatusEnum = Object.freeze({
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED'
});

export const TransactionsSyncProviderEnum = Object.freeze({
  B3: 666
});
